import { useState } from 'react';
import { Period } from './types';
import { getDateRange } from './helpers';
import { PERIODS } from './constants';

export type DateRangeState = {
  name: Period;
  year?: number;
  quarter?: number | undefined;
  dateString?: string;
};

export const useDateRange = () => {
  const { year, quarter, dateString } = getDateRange({ period: PERIODS[0] });

  const [dateRange, setDateRange] = useState<DateRangeState>({
    name: PERIODS[0],
    dateString: dateString,
    year: year,
    quarter: quarter,
  });

  return {
    dateRange,
    setDateRange,
  };
};
